import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import { useLocation } from '@reach/router';
import { Helmet } from 'react-helmet';

const Seo = (props) => {
	const { meta } = props;
	const { site } = useStaticQuery(graphql`
		query SeoMetaData {
			site {
				siteMetadata {
					title
					description
					siteUrl
						og {
						  siteName
						  twitterCreator
						}
				}
			}
		}
	`);

	const title = meta && meta.title ? meta.title : site.siteMetadata.title;
	const description = meta && meta.description ? meta.description : site.siteMetadata.description;
	const image = meta && meta.heroimage ? meta.heroimage : '';

	const location = useLocation();
	let canonical = `${site.siteMetadata.siteUrl}${location.pathname}`;
	if (canonical.substring(canonical.length-5) !== '.html' && canonical.substring(canonical.length-1) !== '/')
		canonical += '/';

	return (
		<Helmet>
			<meta property='description' content={description} />
			<meta property='og:url' content={canonical} />
			<meta property='og:type' content='website' />
			<meta property='og:title' content={title} />
			<meta property='og:image' content={image} />
			<meta property='og:description' content={description} />
			<meta property='og:site_name' content={site.siteMetadata.og.siteName} />
			<meta property='twitter:card' content='summary_large_image' />
			<meta property='twitter:creator' content={site.siteMetadata.og.twitterCreator} />
			<link rel='me' href='https://mas.to/@towerofthehand' />
			<link rel='canonical' href={canonical} />
		</Helmet>
	);
};

export default Seo;
